import { render, staticRenderFns } from "./ClientContactDetailsForm.vue?vue&type=template&id=707aea41&scoped=true&"
import script from "./ClientContactDetailsForm.vue?vue&type=script&lang=js&"
export * from "./ClientContactDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientContactDetailsForm.vue?vue&type=style&index=0&id=707aea41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707aea41",
  null
  
)

export default component.exports